// src/utils/endpoint.js
// export const REACT_APP_API_URL = 'http://localhost:5010/prutl-api';
// export const REACT_APP_API_URL = 'http://localhost:5010/prutl-api';

// export const REACT_APP_API_URL = 'http://103.224.247.193:5010/prutl-api';
// export const REACT_APP_API_URL = 'http://prutl.passionit.com/prutl-api';
export const REACT_APP_API_URL = 'https://prutl1.passionit.com/prutl-api';
